<div class="notification-template">
  @switch (toastMessage) {
    @case ("ShowOrderCreated") {
      <span class="toast-container-create"
        >New order created -
        <a href="#" routerLink="{{ orderType }}/orders/{{ orderId }}">
          <u> {{ orderName }} </u>
        </a>
      </span>
    }
    @case ("ItemAdded") {
      <div class="toast-container-custom">
        <div class="toast-image-container">
          <img
            class="toast-image"
            src="{{ showItemUrl }}"
            width="60"
            height="60"
            alt="showItemName"
          />
        </div>
        <div class="toast-content">
          <div class="toast-item-name">
            <strong>{{ showItemName }}</strong>
          </div>
          <div class="toast-item-name">was successfully added to</div>
          <div class="toast-item-name">
            @if (!orderId) {
              <span>your order</span>
            }
            @if (!!orderId) {
              <a href="#" routerLink="{{ orderType }}/orders/{{ orderId }}">
                <u>{{ orderName }}</u>
              </a>
            }
            .
          </div>
          <div class="toast-item-name">{{ warningUp }}</div>
          <div class="toast-item-name">{{ warningDown }}</div>
        </div>
      </div>
    }
  }
</div>
